import { HttpParams } from '@angular/common/http';

export abstract class URLParamsService {

  public static buildUrl(baseUrl: string, params: any): string {
    const saniteze = JSON.parse(JSON.stringify(params));
    const httpParams = new HttpParams({ fromObject: saniteze });

    return `${baseUrl}?${httpParams.toString()}`;
  }
}
